import * as React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { ScrollbarProps, positionValues } from 'react-custom-scrollbars';

interface IShadowScrollbarProps extends ScrollbarProps {
	id: string;
	horizontalOnly?: boolean;
	verticalOnly?: boolean;
	autoScrollSelected?: boolean;
}

interface IShadowScrollbarState {
	shadowTopVisibility: boolean;
	shadowBottomVisibility: boolean;
}

export class ShadowScrollbar extends React.Component<IShadowScrollbarProps, IShadowScrollbarState> {
	private scrollbars: React.RefObject<Scrollbars> = null;
	private scrollbarsId: string = 'scrollbars_container_';

	constructor(props: IShadowScrollbarProps) {
		super(props);

		this.state = {
			shadowTopVisibility: false,
			shadowBottomVisibility: false
		}

		this.scrollbars = React.createRef();
		this.scrollbarsId = this.scrollbarsId + this.props.id;

		this.handleUpdate = this.handleUpdate.bind(this);
		this.onMouseWheel = this.onMouseWheel.bind(this);
	}

	public componentDidMount(): void {
		if (this.props.autoScrollSelected) {
			let selectedItems = document.getElementById(this.scrollbarsId).getElementsByClassName('selected');
			if (selectedItems.length > 0) {
				setTimeout(() => {
					let selectedElement: any = selectedItems[0];
					if (selectedElement && selectedElement.offsetLeft > 0) {
						this.scrollbars.current.scrollLeft(selectedElement.offsetLeft);
					}
					if (selectedElement && selectedElement.offsetTop > 0) {
						this.scrollbars.current.scrollTop(selectedElement.offsetTop);
					}
				}, 100);
			}
		}
	}

	private handleUpdate(values: positionValues) {
		this.setState({
			shadowTopVisibility: values.top > 0,
			shadowBottomVisibility: values.top < 0.99 && values.scrollHeight > values.clientHeight,
		});
	}

	private onMouseWheel(e: any): void {
		if (this.props.horizontalOnly) {
			if (e.deltaY > 0) {
				this.scrollbars.current.scrollLeft(this.scrollbars.current.getScrollLeft() + 50);
			}
			else if (e.deltaY < 0) {
				this.scrollbars.current.scrollLeft(this.scrollbars.current.getScrollLeft() - 50);
			}
		}
	}

	render() {
		let { ...props } = this.props;
		delete props.horizontalOnly;
		delete props.verticalOnly;
		delete props.autoScrollSelected;
		let containerStyle = {
			...this.props.style
		};

		return (
			<div id={this.scrollbarsId} className="scroll-container" style={containerStyle}>
				<Scrollbars ref={this.scrollbars} onUpdate={this.handleUpdate} onWheel={(e) => this.onMouseWheel(e)} {...props} />
				{
					this.state.shadowTopVisibility &&
					<div className="shadow-top" ref="shadowTop" />
				}
				{
					this.state.shadowBottomVisibility &&
					<div className="shadow-bottom" ref="shadowBottom" />
				}
			</div>
		);
	}
}

export default ShadowScrollbar;